import { takeEvery, put } from 'redux-saga/effects';
import { FETCH_POPUP_DATA } from './ActionTypes';
import { select } from 'redux-saga/effects';
import { getService, getAxiosHeaders } from "../../../library/RestAPI";
import { 
  getFinalURL,
  SET_POPUP_DATA,
  SET_POPUP_OPEN,
  SET_POPUP_LOADER,
  SET_POPUP_PAGINATION,
  SET_POPUP_AGGREGATION_DATA,
  OPEN_DETAILS_POPUP,
  getAlertAggregationURL,
  getTotalHierarcyKey,
  staticAlertCount,
 } from './ActionTypes';

 function processData(data) {
  // Process data if needed before setting in state
  if (Array.isArray(data.content)) {
    data.content = data.content.map(item => {
      if (item && typeof item === 'object' && 'time' in item) {
        return { ...item, date: item.time };
      }
      return item;
    });
  }
  return data;
}

function* fetchPopupData(action) {
  try {
    yield put({ type: SET_POPUP_LOADER, payload: true });
    const popupOpen = yield select((state) => state.DataguardReducer.popupOpen);
    const popupDetails = yield select((state) => state.DataguardReducer.popupDetails);
    const fromTimeStamp = yield select((state) => state.DataguardReducer.fromTimeStamp);
    const toTimeStamp = yield select((state) => state.DataguardReducer.toTimeStamp);
    const popupPagination = yield select((state) => state.DataguardReducer.popupPagination);
    const page = popupPagination.page;
    const pageSize = popupPagination.pageSize;
    if (!popupOpen || !popupDetails) return; // Only fetch if popup is open
    const apiEndpoint = getFinalURL(popupDetails.hierarchy, { ...popupDetails, fromTimeStamp, toTimeStamp, page, pageSize });
    const alertAggregationURL = getAlertAggregationURL(popupDetails.hierarchy, fromTimeStamp, toTimeStamp, popupDetails);
    if (alertAggregationURL) {
      const optionsAlertAgg = {
        method: "GET",
        url: alertAggregationURL,
        headers: getAxiosHeaders(true),
      };
      const aggregationResponse = yield getService(optionsAlertAgg);
      if (aggregationResponse && aggregationResponse.status === 200) {
        yield put({
          type: SET_POPUP_AGGREGATION_DATA,
          payload: aggregationResponse.data
        });
      }
    }
    const options = {
      method: "GET",
      url: apiEndpoint,
      headers: getAxiosHeaders(true),
    };

    const response = yield getService(options);
    if (response && response.status === 200) {
      if (staticAlertCount.includes(getTotalHierarcyKey(popupDetails.hierarchy))) {
        yield put({
          type: SET_POPUP_AGGREGATION_DATA,
          payload: [{ totalCount: response.data.totalElements, policyName: popupDetails.subtitleDisplayName }]
        });
      }
      yield put({
        type: SET_POPUP_DATA,
        payload: {
          data: processData(response.data),
        }
      });
    }
    yield put({ type: SET_POPUP_LOADER, payload: false });
  } catch (error) {
    yield put({ type: SET_POPUP_LOADER, payload: false });
    console.error("Error fetching popup data:", error);
    // Still show popup with error message
    yield put({
      type: SET_POPUP_DATA,
      payload: {
        data: null,
      }
    });
  }
}

function* openDetailsPopup(action) {
  try {
    yield put({ type: SET_POPUP_LOADER, payload: true });

    // Open the popup immediately
    yield put({
      type: SET_POPUP_OPEN,
      payload: {
        open: true,
        popupDetails: action.payload,
      }
    });
  } catch (error) {
    yield put({ type: SET_POPUP_LOADER, payload: false });
    console.error("Error fetching popup data:", error);

    // Still show popup with error message
    yield put({
      type: SET_POPUP_DATA,
      payload: {
        data: null,
      }
    });
  }
}

function* DataGuardPopupSaga() {
  yield takeEvery(FETCH_POPUP_DATA, fetchPopupData);
  yield takeEvery(OPEN_DETAILS_POPUP, openDetailsPopup);
}

export default DataGuardPopupSaga;